import { Comment_Base } from '~/common/typescript/models/Comment';

export const CommentItemUtil = {
  zoomToComment: (comment: Comment_Base) => {
    if (!window.map) return;
    const lngLat = JSON.parse(comment.geojson!).coordinates;
    window.map.flyTo({
      center: [lngLat[0], lngLat[1]],
      zoom: 15,
    });
  },
};
